export const cardDetails = {
    BANK_CARD: {
        AUTHORIZED: { fields: ['owner', 'validDates', 'contactless'] },
        MAIN: { fields: ['owner', 'validDates', 'contactless'] },
    },
    CREDIT: {
        AUTHORIZED: {
            fields: [
                [
                    'currentCycleEndDate',
                    'outstandingMonthlyAmount',
                    'minimalMonthlyAmount',
                    'installmentDueDate',
                ],
                ['owner', 'validDates', 'contactless'],
            ],
        },
        MAIN: {
            fields: [
                ['outstandingAmount', 'balance', 'limit'],
                [
                    'currentCycleEndDate',
                    'outstandingMonthlyAmount',
                    'minimalMonthlyAmount',
                    'installmentDueDate',
                ],
                ['owner', 'validDates', 'contactless'],
            ],
        },
    },
    VIRTUAL_CREDIT: {
        AUTHORIZED: {
            fields: [
                [
                    'currentCycleEndDate',
                    'outstandingMonthlyAmount',
                    'minimalMonthlyAmount',
                    'installmentDueDate',
                ],
                ['owner', 'validDates', 'contactless'],
            ],
        },
        MAIN: {
            fields: [
                ['outstandingAmount', 'balance', 'limit'],
                [
                    'currentCycleEndDate',
                    'outstandingMonthlyAmount',
                    'minimalMonthlyAmount',
                    'installmentDueDate',
                ],
                ['owner', 'validDates', 'contactless'],
            ],
        },
    },
    VIRTUAL_DEBIT: {
        AUTHORIZED: { fields: ['owner', 'validDates', 'contactless'] },
        MAIN: { fields: ['owner', 'validDates', 'contactless'] },
    },
};
